import { Construction } from 'lucide-react';
import { Card, CardBody, CardHeader, CardTitle } from '@pnl/ui';

export interface PlaceholderPageProps {
  title: string;
  marker: string; // ex: "M1.10", "M3.8"
  description?: string;
}

export function PlaceholderPage({ title, marker, description }: PlaceholderPageProps) {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-2xs text-brand-500 font-semibold uppercase tracking-widest">{marker}</p>
        <h1 className="font-display text-ink-900 mt-1 text-3xl font-semibold tracking-tight">
          {title}
        </h1>
        {description && <p className="text-ink-500 mt-1 text-sm">{description}</p>}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Em construção</CardTitle>
        </CardHeader>
        <CardBody className="text-ink-500 flex flex-col items-center gap-3 py-16 text-center">
          <Construction size={32} />
          <p className="text-sm">
            Esta tela será implementada no marco{' '}
            <span className="font-mono font-semibold">{marker}</span>.
          </p>
        </CardBody>
      </Card>
    </div>
  );
}
